import { render, staticRenderFns } from "./ScreenLoader.vue?vue&type=template&id=3662bb06&scoped=true"
import script from "./ScreenLoader.vue?vue&type=script&lang=js"
export * from "./ScreenLoader.vue?vue&type=script&lang=js"
import style0 from "./ScreenLoader.vue?vue&type=style&index=0&id=3662bb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3662bb06",
  null
  
)

export default component.exports